<script lang="ts">
    import Btn from "../components/Btn.svelte";
    import Container from "../components/Container.svelte";
    import Divider from "../components/Divider.svelte";
    import Dropdown from "../components/Dropdown.svelte";
    import Gap from "../components/Gap.svelte";
    import Headline from "../components/Headline.svelte";
    import Hero from "../components/Hero.svelte";
    import Image from "../components/Image.svelte";
    import LightTheme from "../components/LightTheme.svelte";
    import PageTransition from "../components/PageTransition.svelte";
    import Row from "../components/Row.svelte";
    import Subline from "../components/Subline.svelte";
    import { fade } from "svelte/transition";
</script>

<LightTheme />

<Hero headline="zuverlässig und <br>schnell" small />

<Container max="800px">
    <center>
        <Headline>Impressum</Headline>
        <Subline>Unsere Daten</Subline>

        <p>
            <b>Sinus Nachrichtentechnik GmbH</b> <br />
            Rahlstedter Straße 13 <br />
            22885 Barsbüttel
        </p>
        <p>
            <b>Vertreten durch:</b> <br />
            Marcus Landschof, Geschäftsführer <br />
            Volker Clausen, Prokurist <br />
            Tel: +49 40 682875 0 <br />
            Fax: +49 40 682875 33 <br />
            kontakt@sinus-nt.de
        </p>
        <p>
            <b>Registereintrag:</b> <br />
            Eintragung im Handelsregister <br />
            Registergericht: Lübeck <br />
            Registernummer: HRB-Nr. 10503 HL <br />
        </p>
        <p>
            Die Filmsequenzen auf den Seiten „Leitstellensysteme und Digitale
            Alarmierung“ unterliegen dem Copyright: © 2023 SAP SE
        </p>
        <p>
            <b>Umsatzsteuer-Identifikationsnummer:</b> <br />
            DE 118711017
        </p>
    </center>
    <Gap height="4rem" />
</Container>

<Gap height="5vw" />

<style lang="scss">
    @import "../vars";
</style>
